import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_a9do4tt1: FaireBrandEntity = {
  token: "b_a9do4tt1",
  type: "brand",
  name: "Zia Pia",
  avatarUrl:
    "https://cdn.faire.com/fastly/01a0ed23c9d9a80ff72ceb4895d91131a9d793ab6617bdda55ac30c87fa9b814.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/1b4e22afab76072ef9fefed12112149373d4611c2360180852c3b40ed14039ac.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/01a0ed23c9d9a80ff72ceb4895d91131a9d793ab6617bdda55ac30c87fa9b814.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/1b4e22afab76072ef9fefed12112149373d4611c2360180852c3b40ed14039ac.jpeg",
  location: "Charlotte, NC, USA",
  minimumOrderDollars: 100,
  rating: 4.9,
  reviewCount: 386,
  isTopShop: true,
  isInsider: true,
  description:
    "Zia Pia is a boutique importer specializing in Italy's authentic regional foods. Our suppliers are non-industrial, family-owned producers who combine traditional principles of authenticity and flavor with Italian design and style to create superior products, beautiful on the inside and out. Named for Victoria's Aunt, or “Zia”, Pia Custodi in Orvieto, Italy, as extraordinary a person as she was a cook, Zia Pia's mission is to select foods that are made simply with care and attention to quality of ingredients. Zia Pia serves fine specialty gift, home and food retailers, markets and restaurants. We look forward to sharing our foods with you. Buon appetito!",
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:19:26.289Z",
    importedBy: "entity-db-cli",
  },
};
